export default __webpack_public_path__ + "static/media/Ellipse 11.2ae7d035.png";